import { HttpLogger } from 'zipkin-transport-http';
import { Tracer, BatchRecorder, jsonEncoder, ExplicitContext, Instrumentation } from 'zipkin';

const ZIPKIN_SERVER_URL = process.env?.REACT_APP_ZIPKIN_SERVER_URL || 'http://localhost:9411';

export const wrapAxios = (axios, options: any = {}) => {
  const { tracer } = options;
  const instrumentation = new Instrumentation.HttpClient(options);
  const zipkinRecordRequest = (config) =>
    tracer.scoped(() => {
      const newConfig = instrumentation.recordRequest(config, config.url, config.method);
      newConfig.traceId = tracer.id;
      return newConfig;
    });
  const zipkinRecordResponse = (res) =>
    tracer.scoped(() => {
      instrumentation.recordResponse(res.config.traceId, res.status);
      return res;
    });
  const zipkinRecordError = (error) =>
    tracer.scoped(() => {
      if (error.config) {
        const { traceId } = error.config;
        if (error.response) {
          instrumentation.recordResponse(traceId, error.response.status);
        } else {
          instrumentation.recordError(traceId, error);
        }
      } // otherwise the error preceded the request interceptor
      return Promise.reject(error);
    });
  let axiosInstance = axios;
  if (axios.create) {
    axiosInstance = axios.create();
  }
  axiosInstance.interceptors.request.use(zipkinRecordRequest, zipkinRecordError);
  axiosInstance.interceptors.response.use(zipkinRecordResponse, zipkinRecordError);
  return axiosInstance;
};

export const ZipkinTracer = new Tracer({
  ctxImpl: new ExplicitContext(),
  recorder: new BatchRecorder({
    logger: new HttpLogger({
      endpoint: `${ZIPKIN_SERVER_URL}/api/v2/spans`,
      jsonEncoder: jsonEncoder.JSON_V2,
    }),
  }),
  localServiceName: 'ccm-office-client',
});
